import { isAxiosError } from "axios";

interface ApiErrorEnvelope {
	success: false;
	error: {
		code: string;
		message: string;
		details?: unknown;
	};
}

/**
 * Backend xatoni `{ success: false, error: { code, message, details } }`
 * ko'rinishida qaytaradi (`packages/core/src/errors.ts`, `AppError.toJSON`).
 * Ba'zi amallar uchun (masalan bo'limni ko'chirish — aylanma yoki chuqurlik
 * chegarasi) foydalanuvchiga aynan shu xabar ko'rsatilishi shart, umumiy
 * xabar emas. Xabar topilmasa `fallback` qaytadi.
 */
export function getErrorMessage(error: unknown, fallback: string): string {
	if (isAxiosError<ApiErrorEnvelope>(error)) {
		const message = error.response?.data?.error?.message;
		if (typeof message === "string" && message.length > 0) {
			return message;
		}
	}

	return fallback;
}
